import React from 'react'

const RealtimeAdvertisingHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
            <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                    <div className='min-w-0 max-w-full'>
                        <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                            Real-Time Online Advertising Platform
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Amazon SQS
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                MySQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Redis
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                              We partnered with a leading Australian advertising and media company to architect a high-performance
                              real-time advertising analytics platform that processes millions of campaign interactions daily. Built with
                              Spring Boot, Angular, and Amazon SQS, the solution delivers instant campaign insights, automated reporting
                              that reduced manual analysis time by 50%, and real-time dashboard updates with sub-second latency. Leveraging
                              MySQL for persistent storage and Redis for caching, the platform handles massive data streams without performance
                              degradation, enabling advertisers to optimize campaigns for maximum ROI through data-driven decision-making.
                            </p>

                    </div>
                    <div className='min-w-0 max-w-full'>
                      <img src='/case_studies/title-banner/advertising-banner.png' alt='Real-Time Online Advertising Platform' className='w-full h-auto max-w-full'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RealtimeAdvertisingHero
